const cities = [
  "Mumbai",
  "Navi Mumbai",
  "New Delhi",
  "Kolkata",
  "Chennai",
  "Bangalore",
  "Hyderabad",
  "Ahmedabad",
  "Thane",
  "Pune",
  "Surat",
  "Jaipur",
  "Kochi",
  "Kozhikode"
];

export default cities;
